import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { SmartSearchListPage } from '@/features/smart-search'

const searchSchema = z.object({
  q: z.string().optional().catch(''),
  limit: z.number().optional().catch(50),
  mode: z.enum(['limit', 'threshold']).optional().catch('limit'),
  threshold: z.number().optional().catch(undefined),
  countries: z.string().optional().catch(''),
  expMin: z.number().optional().catch(undefined),
  expMax: z.number().optional().catch(undefined),
  empMin: z.number().optional().catch(undefined),
  empMax: z.number().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/company-jobs/smart-search/')({
  validateSearch: searchSchema,
  component: SmartSearchListPage,
})
